var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.computed_class,attrs:{"href":_vm.representation,"target":"_blank"}},[_vm._v(_vm._s(_vm.representation))])}
var staticRenderFns = []

export { render, staticRenderFns }